export interface PontoDeTela {
  x: number
  y: number
}

/**
 * Quanto o ponteiro pode andar entre pressionar e soltar e ainda valer como
 * clique, em pixels de tela.
 *
 * A folga existe porque dedo e mouse sempre tremem alguns pixels: tolerância
 * zero transformaria clique legítimo em arrasto.
 */
export const TOLERANCIA_CLIQUE_PX = 6

/**
 * O gesto foi arrasto (órbita de câmera), e não clique?
 *
 * Girar a câmera começa e termina sobre o mesmo plano de solo que recebe o
 * clique de posicionar equipamento — sem esta distinção, cada órbita largava um
 * calço no chão. Sem registro de onde o gesto começou, trata como clique: é o
 * comportamento antigo, e é o que vale para um toque que nasce fora da cena.
 */
export function ponteiroArrastou(
  pressao: PontoDeTela | null,
  solta: PontoDeTela,
  tolerancia = TOLERANCIA_CLIQUE_PX,
): boolean {
  if (!pressao) return false
  return Math.hypot(solta.x - pressao.x, solta.y - pressao.y) > tolerancia
}
